import { useOnDocumentUnloaded } from './useOnDocumentUnloaded';
export default useOnDocumentUnloaded;